/**
 * SignInModal.jsx
 * Created by michaelbray on 2/14/18.
 * Updated by Destin Frasier on 1/11/19.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { withRouter } from 'react-router';

import { FlexRow, FlexCol } from '../../../sharedComponents/FlexGrid';
import * as Icons from '../../../sharedComponents/icons/Icons';
import * as BrandingIcons from '../../../sharedComponents/icons/branding/BrandingIcons';
import Button from '../../../sharedComponents/Button';
import SignInForm from './SignInForm';

import { LOCATION } from '../../../../types/react-router-types';
import { ACCOUNT_PROPS, LOGIN_NOTICE_PROPS } from '../../constants';


const propTypes = {
    location: LOCATION,
    disableAccountFeatures: PropTypes.bool,
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    create: PropTypes.func,
    reset: PropTypes.func,
    login: PropTypes.func,
    error: PropTypes.bool,
    lockout: PropTypes.bool,
    mfaRequired: PropTypes.bool,
    mfaValidation: PropTypes.bool,
    account: ACCOUNT_PROPS,
    loginNotice: LOGIN_NOTICE_PROPS
};

const defaultProps = {
    disableAccountFeatures: false,
    isOpen: false,
    closeModal: () => { },
    create: () => { },
    reset: () => { },
    login: () => { },
    error: false,
    account: null
};

export class SignInModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            password: '',
            errorText: null
        };

        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.signIn = this.signIn.bind(this);
        this.confirmSignIn = this.confirmSignIn.bind(this);
    }

    componentDidMount() {
        Modal.setAppElement('body');
    }

    componentDidUpdate(prevProps) {
        const {
            account,
            isOpen
        } = this.props;

        if (prevProps.account === null && account && isOpen) {
            // Successful login
            this.props.closeModal();
        }
    }

    afterOpenModal() {
        this.setState({
            email: '',
            password: '',
            errorText: null
        });
    }

    signIn() {
        const { location } = this.props;
        const redirectUrl = location?.query?.redirect;

        if (this.state.email.length < 1 || this.state.password.length < 1) {
            this.setState({
                errorText: 'All fields are required.'
            });
        }
        else {
            this.setState({
                errorText: null
            });

            const loginData = {
                username: this.state.email,
                password: this.state.password,
                recaptchaToken: this.state.recaptchaToken,
                userAgent: navigator.userAgent,
                redirectUrl
            };

            this.props.login(loginData);
        }
    }

    confirmSignIn(account) {
        this.setState({
            email: account.email,
            password: account.password,
            recaptchaToken: account.recaptchaToken,
            errorText: null
        }, () => {
            this.signIn();
        });
    }

    render() {
        let errorText = this.state.errorText;
        if (this.props.error) {
            errorText = 'Are you sure you have the right email and password? Please double check your email and password, and try again. You can also click the links below to sign up for an account or reset your password.';
        }

        if (this.props.lockout) {
            errorText = 'This account has been locked out for 30 minutes due to three or more failed login attempts. To access your account before then, check your e-mail for a magic login link or reset your password by clicking on the "Reset Password" link below. If you do not receive your magic log in email, please check your spam folder.';
        }
        return (
            <Modal
                role="complementary"
                isOpen={this.props.isOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.props.closeModal}
                className={{
                    base: 'rec-modal-dialog-base',
                    afterOpen: 'rec-modal-dialog-after-open-md rec-acct-modal rec-acct-signin-modal',
                    beforeClose: 'rec-modal-dialog-before-close'
                }}
                overlayClassName={{
                    base: 'rec-overlay-base',
                    afterOpen: 'rec-overlay-after-open',
                    beforeClose: 'rec-overlay-before-close'
                }}
                aria={{
                    labelledby: "signInModalHeading"
                }}
                ariaHideApp={false}>
                <div className="rec-modal-content-wrap">
                    <FlexRow justifyContent="space-between">
                        <FlexCol className="rec-modal-logo">
                            <BrandingIcons.Logo />
                        </FlexCol>
                        <FlexCol xs="variable">
                            <Button
                                appearance="subtle"
                                iconBeforeElement={<Icons.IconClose />}
                                screenReaderTextBefore="Close Log In Dialog"
                                onClick={this.props.closeModal}
                                className="rec-close-modal" />
                        </FlexCol>
                    </FlexRow>

                    <SignInForm
                        disableAccountFeatures={this.props.disableAccountFeatures}
                        errorText={errorText}
                        create={this.props.create}
                        reset={this.props.reset}
                        confirmSignIn={this.confirmSignIn}
                        mfaValidation={this.props.mfaValidation}
                        mfaRequired={this.props.mfaRequired}
                        loginNotice={this.props.loginNotice} />
                </div>
            </Modal>
        );
    }
}

SignInModal.propTypes = propTypes;
SignInModal.defaultProps = defaultProps;

export default withRouter(SignInModal);